import { styled } from '@material-ui/styles';
import CardActions from '@material-ui/core/CardActions';

export const RightCardActions = styled(CardActions)({
  flexDirection: 'row-reverse',
  margin: '0 0.5em 0.5em',
});
